import { render, staticRenderFns } from "./SummaryTravel.vue?vue&type=template&id=59ca973d&"
import script from "./SummaryTravel.vue?vue&type=script&lang=js&"
export * from "./SummaryTravel.vue?vue&type=script&lang=js&"
import style0 from "./SummaryTravel.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports